enum ChipStatus {
  ATTENTION = "attention",
  INFO = "info",
  ALERT="alert",
}

export default ChipStatus;